import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import { components } from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import { realizarDonacion } from "../../services/services";
import style from "../index.module.css";
import { styleSelect, styleSelectWithValue } from "../constants/select-style";
import ThankYouAlert from "../thank-modal/thank-modal";
import GlobalContext from "../../context/formContext";

// Función para validar el IBAN
/**
 *
 * @param {string} value
 * @param {Array<string>} codes
 * @returns
 */
const validateIBAN = (value, codes) => {
  // Patrón básico para validar estructura de IBAN (simplificado para demostración)
  return codes.includes(value.substring(4, 8));
};
/**
 *
 * Formulario de donaciones hazte socio
 */
export default function PartnerForm() {
  const { config, urlBase } = useContext(GlobalContext);

  const [documentSelectedValue, setDocumentSelectedValue] = useState(false);
  const [fileNameSelected, setfileNameSelected] = useState(
    "Copia del pasaporte*"
  );
  const [selectedOption, setSelectedOption] = useState("unselected");
  const [frequencySelectedOption, setfrequencySelectedOption] =
    useState("unselected");
  const [labelClickSelected, setLabelClickSelected] = useState("unselected");
  const [labelFreqClickSelected, setLabelFreqClickSelected] =
    useState("unselected");
  const [showDocumentTypeError, setShowDocumentTypeError] = useState(false);
  const [showDonationFrequencyError, setShowDonationFrequencyError] =
    useState(false);
  const [passportFileBase64, setPassportFileBase64] = useState([]);
  const [policePrivacity, setPolicePrivacity] = useState(false);
  const [showPolicePrivacityError, setShowPolicePrivacityError] =
    useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [error, setError] = useState();
  const [passportFile, setPassportFile] = useState([]);
  const [loading, setloading] = useState(false);

  const documentsOptions = [
    { value: "dni_nie", label: "DNI/NIE" },
    { value: "cif", label: "CIF" },
    { value: "pasaporte", label: "Pasaporte" },
  ];
  const frequencyOptions = [
    { value: "mensual", label: "Mensual" },
    { value: "anual", label: "Anual" },
  ];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      nameRazon: "",
      documentIdType: "unselected",
      documentNumber: "",
      fiscalAddress: "",
      province: "",
      country: "",
      email: "",
      phone: "",
      donationAmount: "",
      donationFrequency: "unselected",
      passportCopy: "",
      iban: "",
    },
    validationSchema: Yup.object({
      nameRazon: Yup.string()
        .matches(/^(?=.*[a-zA-Z]).+$/, "Debe contener caracteres")
        .required("Campo requerido"),
      documentIdType: Yup.string()
        .notOneOf(["unselected"], "Campo requerido")
        .required("Campo requerido"),
      donationFrequency: Yup.string()
        .notOneOf(["unselected"], "Campo requerido")
        .required("Campo requerido"),
      documentNumber: Yup.string()
        .matches(
          /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{8,10}$/,
          "Número de documento no válido"
        )
        .required("Campo requerido"),
      fiscalAddress: Yup.string()
        .matches(
          /^[a-zA-ÄÖÜäöüßÀÁÈÉÌÍÒÓÙÚàáèéìíòóùúÂÊÎÔÛâêîôûÃÕÑãõñËÏÙëïüºª\s\u00f1\u00d1\u0020-\u007E]{5,}$/,
          "Dirección no válida"
        )
        .min(5, "Dirección no válida")
        .required("Campo requerido"),
      province: Yup.string()
        .matches(
          /^[A-Za-ÄÖÜäöüßÀÁÈÉÌÍÒÓÙÚàáèéìíòóùúÂÊÎÔÛâêîôûÃÕÑãõñËÏÙëïü\s\u00f1\u00d1\u0020-\u007E]+$/,
          "Solo puede contener caracteres"
        )
        .required("Campo requerido"),
      country: Yup.string()
        .matches(
          /^[a-zA-ÄÖÜäöüßÀÁÈÉÌÍÒÓÙÚàáèéìíòóùúÂÊÎÔÛâêîôûÃÕÑãõñËÏÙëïü\s\u00f1\u00d1]+$/,
          "Solo puede contener caracteres"
        )
        .min(4, "Debe tener al menos 4 caracteres")
        .required("Campo requerido"),
      email: Yup.string()
        .email("Formato de email inválido")
        .required("Campo requerido"),
      phone: Yup.string()
        .matches(/^\+?[0-9]+$/, "Solo puede contener dígitos")
        .min(9, "Teléfono con formato incorrecto (9 dígitos)")
        .required("Campo requerido"),
      donationAmount: Yup.number()
        .typeError("Campo requerido")
        .positive("Debe ser un número positivo")
        .integer("Debe ser un número entero mayor que cero")
        .nonNullable("Campo requerido")
        .required("Campo requerido"),
      iban: Yup.string()
        .required("Campo requerido")
        .transform((value, originalValue) => {
          return originalValue.replace(/\s/g, "");
        })
        .length(
          24,
          "Por favor, introduce un IBAN válido, tiene que tener 24 caracteres"
        ).test("is-iban", "El número de cuenta bancaria no está permitido", (value) => validateIBAN(value, config.codesBanks)),
    }),

    onSubmit: async (values, { resetForm }) => {
      if (policePrivacity === false) {
        setShowPolicePrivacityError(true);
        return false;
      } else {
        setShowPolicePrivacityError(false);
      }
      setloading(true);
      const response = await enviarDonacion(values);
      //const response = { status: 200, data: [] };
      setloading(false);
      if (response.errors) {
        const error = response.errors.toString();
        switch (error) {
          case "400":
            setError("Los datos introducidos son incorrectos.");
            break;
          case "429":
            setError(
              "Gracias por tu donación. Para realizar otra, debe esperar unos minutos"
            );
            break;
          default:
            setError("Ha ocurrido un error, vuelva a intentarlo.");
            break;
        }
      }
      if (response !== false && response !== undefined && !response.errors) {
        setShowThankYou(true);
        setfileNameSelected("Copia del pasaporte*");
        setSelectedOption("unselected");
        setfrequencySelectedOption("unselected");
        setLabelClickSelected("unselected");
        setLabelFreqClickSelected("unselected");
        setPolicePrivacity(false);
        setShowPolicePrivacityError(false);
        setError();
        resetForm();
      } else {
        setTimeout(() => {
          setError();
        }, 5000);
      }
    },
  });

  useEffect(() => {
    triggerChangeRadio();
  }, [labelClickSelected]);

  useEffect(() => {
    triggerChangeRadioFreq();
  }, [labelFreqClickSelected]);

  const triggerChangeRadio = () => {
    setSelectedOption(labelClickSelected);
    formik.setFieldValue("documentIdType", labelClickSelected);
    formik.setFieldValue("passportCopy", "");
    setfileNameSelected("Copia del pasaporte*");
    if (labelClickSelected === "pasaporte") setDocumentSelectedValue(true);
    else setDocumentSelectedValue(false);
  };

  function triggerChangeRadioFreq() {
    setfrequencySelectedOption(labelFreqClickSelected);
    formik.setFieldValue("donationFrequency", labelFreqClickSelected);
  }

  const handleSelectingFile = (event) => {
    let file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result;
      //console.log(base64String);
      const ext = file.type.split("/");
      setPassportFile({
        name: file.name,
        extension: ext[1],
        base64: base64String,
      });
    };
    reader.readAsDataURL(file);
    formik.handleChange(event);
    setfileNameSelected(file.name);
  };
  const enviarDonacion = async (params) => {
    try {
      let paramstoSend = {};
      paramstoSend["firstName"] = params.nameRazon;
      paramstoSend["lastName"] = null;
      paramstoSend["documentNumber"] = params.documentNumber;
      paramstoSend["prefix"] = null;
      paramstoSend["phone"] = params.phone;
      paramstoSend["email"] = params.email;
      paramstoSend["address"] = params.fiscalAddress;
      paramstoSend["postalCode"] = null;
      paramstoSend["city"] = null;
      paramstoSend["province"] = params.province;
      paramstoSend["country"] = params.country;
      paramstoSend["accountNumber"] = params.iban.replace(/\s/g, ""); //params.iban.replace(/(.{4})(?=(.{4})+(?!.{5}))/g, '$1-');
      paramstoSend["amount"] = params.donationAmount;
      paramstoSend["type"] = 0;
      paramstoSend["files"] = [];
      if (passportFile.length !== 0) paramstoSend["files"].push(passportFile);
      paramstoSend["dateTime"] = new Date();
      paramstoSend["periodicityType"] =
        params.donationFrequency === "mensual" ? 0 : 1;
      switch (params.documentIdType) {
        case "dni_nie":
          paramstoSend["documentType"] = 0;
          break;
        case "cif":
          paramstoSend["documentType"] = 1;
          break;
        case "pasaporte":
          paramstoSend["documentType"] = 2;
          break;
        default:
          paramstoSend["documentType"] = 0;
          break;
      }
      let showError = false;
      if (
        params.documentIdType === 0 ||
        params.documentIdType === "" ||
        params.documentIdType === "unselected"
      ) {
        setShowDocumentTypeError(true);
        showError = true;
      } else {
        setShowDocumentTypeError(false);
      }
      if (
        params.donationFrequency === "unselected" ||
        params.donationFrequency === ""
      ) {
        setShowDonationFrequencyError(true);
        showError = true;
      } else {
        setShowDonationFrequencyError(false);
      }
      if (showError === true) {
        return false;
      } else {
        return await realizarDonacion({ urlBase, params: paramstoSend });
      }
    } catch (error) {
      console.error(
        "Error al realizar la donación:",
        error.response.data.HttpStatusCode
      );
      return {
        errors: error.response.data.HttpStatusCode,
        RemainingSeconds:
          error.response.data?.Attributes?.RemainingSeconds || null,
      };
    }
  };

  const handleOptionChange = (event) => {
    console.log("cambiando el campo");
    let value_selected = event.target.value;
    setSelectedOption(value_selected);
    formik.setFieldValue("documentIdType", value_selected);
    formik.setFieldValue("passportCopy", "");
    setfileNameSelected("Copia del pasaporte*");
    if (value_selected === "unselected") setShowDocumentTypeError(true);
    else setShowDocumentTypeError(false);
    if (value_selected === "pasaporte") setDocumentSelectedValue(true);
    else setDocumentSelectedValue(false);
  };

  const handleFrequencyOptionChange = (event) => {
    let value_selected = event.target.value;
    setfrequencySelectedOption(value_selected);
    if (value_selected === "unselected") setShowDonationFrequencyError(true);
    else setShowDonationFrequencyError(false);
    formik.setFieldValue("donationFrequency", value_selected);
  };

  const CheckboxOption = ({ children, ...props }) => (
    <components.Option {...props}>
      <div className={style.card_select_class_style}>
        <input
          type="radio"
          name={props.data.value}
          id={props.data.value}
          value={props.data.value}
          checked={selectedOption === props.data.value}
          onChange={handleOptionChange}
        />
        <label
          className={style.selec_label}
          htmlFor={props.data.value}
          onClick={() => setLabelClickSelected(props.data.value)}
        >
          {props.data.label}
        </label>
      </div>
    </components.Option>
  );
  const CheckboxFrequencyOption = ({ children, ...props }) => (
    <components.Option {...props}>
      <div className={style.card_select_class_style}>
        <input
          type="radio"
          id={props.data.value}
          value={props.data.value}
          checked={frequencySelectedOption === props.data.value}
          onChange={handleFrequencyOptionChange}
        />
        <label
          className={style.selec_label}
          htmlFor={props.data.value}
          onClick={() => setLabelFreqClickSelected(props.data.value)}
        >
          {props.data.label}
        </label>
      </div>
    </components.Option>
  );
  const handleBlur = (e) => {
    setError();
    formik.handleBlur(e);
  };
  function clickOnSendForm() {
    if (policePrivacity === false) {
      setShowPolicePrivacityError(true);
    }else{
      setShowPolicePrivacityError(false);
    }
  }
  return (
    <form
      onSubmit={formik.handleSubmit}
      className={style.form_container_class_style}
    >
      {showThankYou && <ThankYouAlert onClose={() => setShowThankYou(false)} />}
      <div className={style.div_container_element_style}>
        <input
          id="nameRazon"
          name="nameRazon"
          type="text"
          className={`${style.name_input_custom} ${
            formik.values.nameRazon
              ? style.input_custom_type_with_value
              : style.input_custom_type
          }`}
          onChange={formik.handleChange}
          onBlur={handleBlur}
          value={formik.values.nameRazon}
          placeholder="Nombre y apellidos o Razón Social*"
        />
        {formik.touched.nameRazon && formik.errors.nameRazon ? (
          <div className={style.error_style_form}>
            {formik.errors.nameRazon}
          </div>
        ) : null}
      </div>
      <div className={style.form_custom}>
        <div className={style.div_container_element_style}>
          <Select
            id="documentIdType"
            name="documentIdType"
            options={documentsOptions}
            components={{ Option: CheckboxOption }}
            styles={
              formik.values.documentIdType === "" ||
              formik.values.documentIdType === "unselected"
                ? styleSelect
                : styleSelectWithValue
            }
            className={[style.mi_select_style_class]}
            placeholder="Selecciona el tipo de Documento*"
            classNamePrefix="select"
            onChange={(option) =>
              formik.setFieldValue(
                "documentIdType",
                option ? option.value : "unselected"
              )
            }
            value={
              documentsOptions.find(
                (option) => option.value === formik.values.documentIdType
              ) || "unselected"
            }
          />
          {formik.touched.documentIdType && formik.errors.documentIdType ? (
            <div className={style.error_style_form}>
              {formik.errors.documentIdType}
            </div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="documentNumber"
            name="documentNumber"
            type="text"
            className={`${
              formik.values.documentNumber
                ? style.input_custom_type_with_value
                : style.input_custom_type
            }`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.documentNumber}
            placeholder="Nº de documento *"
          />
          {formik.touched.documentNumber && formik.errors.documentNumber ? (
            <div className={style.error_style_form}>
              {formik.errors.documentNumber}
            </div>
          ) : null}
        </div>
        {documentSelectedValue ? (
          <>
            <div className={style.div_container_element_style}>
              <input
                id="nation"
                name="nation"
                type="text"
                className={`${
                  formik.values.nation
                    ? style.input_custom_type_with_value
                    : style.input_custom_type
                }`}
                onChange={formik.handleChange}
                onBlur={handleBlur}
                value={formik.values.nation}
                placeholder="Nacionalidad*"
              />
              {formik.touched.nation && formik.errors.nation ? (
                <div className={style.error_style_form}>
                  {formik.errors.nation}
                </div>
              ) : null}
            </div>
            <div className={style.div_container_element_style}>
              <div
                className={`${
                  fileNameSelected === "Copia del pasaporte*"
                    ? style.file_upload_design_style_class
                    : style.file_upload_design_style_class_with_value
                }`}
              >
                <p
                  className={`${
                    fileNameSelected === "Copia del pasaporte*"
                      ? style.passport_name_style
                      : style.passport_name_style_with_value
                  }`}
                >
                  {fileNameSelected}
                </p>
                <div className={style.passport_click_container}>
                  <label>Adjuntar Archivo</label>
                  <svg
                    width="7"
                    height="16"
                    viewBox="0 0 7 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_11_2701)">
                      <path
                        d="M3.76577 0.1651C2.90827 0.166079 2.08618 0.507154 1.47983 1.1135C0.873489 1.71984 0.532414 2.54194 0.531435 3.39944V13.4096C0.52747 13.7306 0.587282 14.0493 0.707404 14.3471C0.827526 14.6448 1.00557 14.9158 1.2312 15.1442C1.45684 15.3727 1.72558 15.554 2.02185 15.6778C2.31811 15.8016 2.63601 15.8654 2.95709 15.8654C3.27818 15.8654 3.59608 15.8016 3.89234 15.6778C4.18861 15.554 4.45735 15.3727 4.68299 15.1442C4.90862 14.9158 5.08666 14.6448 5.20679 14.3471C5.32691 14.0493 5.38672 13.7306 5.38275 13.4096V3.39944C5.38275 2.97059 5.21239 2.5593 4.90915 2.25606C4.60591 1.95281 4.19462 1.78245 3.76577 1.78245C3.33692 1.78245 2.92563 1.95281 2.62239 2.25606C2.31915 2.5593 2.14879 2.97059 2.14879 3.39944V12.1966C2.14715 12.2508 2.15639 12.3046 2.17597 12.3551C2.19555 12.4056 2.22507 12.4516 2.26277 12.4905C2.30046 12.5293 2.34558 12.5602 2.39544 12.5813C2.4453 12.6024 2.49889 12.6133 2.55303 12.6133C2.60717 12.6133 2.66076 12.6024 2.71062 12.5813C2.76048 12.5602 2.8056 12.5293 2.8433 12.4905C2.881 12.4516 2.91051 12.4056 2.93009 12.3551C2.94967 12.3046 2.95892 12.2508 2.95728 12.1966V3.39944C2.95728 3.18501 3.04246 2.97937 3.19408 2.82775C3.3457 2.67612 3.55135 2.59094 3.76577 2.59094C3.9802 2.59094 4.18584 2.67612 4.33746 2.82775C4.48908 2.97937 4.57426 3.18501 4.57426 3.39944V13.4096C4.56784 13.8342 4.39463 14.2393 4.09205 14.5374C3.78947 14.8354 3.38181 15.0024 2.95709 15.0024C2.53238 15.0024 2.12471 14.8354 1.82213 14.5374C1.51956 14.2393 1.34635 13.8342 1.33993 13.4096V3.39944C1.33993 2.75606 1.59551 2.13904 2.05044 1.68411C2.50537 1.22917 3.1224 0.973592 3.76577 0.973592C4.40914 0.973592 5.02617 1.22917 5.4811 1.68411C5.93604 2.13904 6.19162 2.75606 6.19162 3.39944V12.1966C6.18998 12.2508 6.19922 12.3046 6.2188 12.3551C6.23838 12.4056 6.26789 12.4516 6.30559 12.4905C6.34329 12.5293 6.38841 12.5602 6.43827 12.5813C6.48813 12.6024 6.54172 12.6133 6.59586 12.6133C6.65 12.6133 6.70359 12.6024 6.75345 12.5813C6.80331 12.5602 6.84843 12.5293 6.88613 12.4905C6.92383 12.4516 6.95334 12.4056 6.97292 12.3551C6.9925 12.3046 7.00174 12.2508 7.00011 12.1966V3.39944C6.99913 2.54194 6.65805 1.71984 6.05171 1.1135C5.44537 0.507154 4.62327 0.166079 3.76577 0.1651Z"
                        fill="#00499A"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11_2701">
                        <rect
                          width="6.46867"
                          height="15.6699"
                          fill="white"
                          transform="translate(0.53125 0.165039)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <input
                id="passportCopy"
                name="passportCopy"
                type="file"
                className={`${style.file_upload_style} ${
                  formik.values.passportCopy
                    ? style.input_custom_type_with_value
                    : style.input_custom_type
                }`}
                onChange={handleSelectingFile}
                onBlur={handleBlur}
                value={formik.values.passportCopy}
                placeholder="Copia del pasaporte*"
              />
              {formik.touched.passportCopy && formik.errors.passportCopy ? (
                <div className={style.error_style_form_passport}>
                  {formik.errors.passportCopy}
                </div>
              ) : null}
            </div>
          </>
        ) : (
          ""
        )}
        <div
          className={`${style.div_container_element_style} ${
            documentSelectedValue ? style.movil_view_conditional : ""
          }`}
        >
          <input
            id="fiscalAddress"
            name="fiscalAddress"
            type="text"
            className={`${
              formik.values.fiscalAddress
                ? style.input_custom_type_with_value
                : style.input_custom_type
            }`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.fiscalAddress}
            placeholder="Domicilio Fiscal*"
          />
          {formik.touched.fiscalAddress && formik.errors.fiscalAddress ? (
            <div className={style.error_style_form}>
              {formik.errors.fiscalAddress}
            </div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="province"
            name="province"
            type="text"
            className={`${
              formik.values.province
                ? style.input_custom_type_with_value
                : style.input_custom_type
            }`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.province}
            placeholder="Provincia*"
          />
          {formik.touched.province && formik.errors.province ? (
            <div className={style.error_style_form}>
              {formik.errors.province}
            </div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="country"
            name="country"
            type="text"
            className={`${
              formik.values.country
                ? style.input_custom_type_with_value
                : style.input_custom_type
            }`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.country}
            placeholder="País*"
          />
          {formik.touched.country && formik.errors.country ? (
            <div className={style.error_style_form}>
              {formik.errors.country}
            </div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="email"
            name="email"
            type="email"
            className={`${
              formik.values.email
                ? style.input_custom_type_with_value
                : style.input_custom_type
            }`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.email}
            placeholder="Email*"
          />
          {formik.touched.email && formik.errors.email ? (
            <div className={style.error_style_form}>{formik.errors.email}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="phone"
            name="phone"
            type="text"
            className={`${
              formik.values.phone
                ? style.input_custom_type_with_value
                : style.input_custom_type
            }`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.phone}
            placeholder="Teléfono*"
          />
          {formik.touched.phone && formik.errors.phone ? (
            <div className={style.error_style_form}>{formik.errors.phone}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="donationAmount"
            name="donationAmount"
            type="number"
            className={`${
              formik.values.donationAmount
                ? style.input_custom_type_with_value
                : style.input_custom_type
            }`}
            onChange={(e) => {
              let value = parseInt(e.target.value, 10); // Convertir el valor a un número entero
              // Verificar si el valor es un número válido y si es negativo
              if (value < 0) {
                value = 0; // Establecer el valor a 0 si es negativo o no es un número válido
              }
              formik.setFieldValue("donationAmount", value); // Actualizar el valor del campo en el formulario
            }}
            onBlur={handleBlur}
            value={formik.values.donationAmount}
            placeholder="Importe a donar en euros*"
          />
          {formik.touched.donationAmount && formik.errors.donationAmount ? (
            <div className={style.error_style_form}>
              {formik.errors.donationAmount}
            </div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <Select
            id="donationFrequency"
            name="donationFrequency"
            options={frequencyOptions}
            styles={
              formik.values.donationFrequency === "" ||
              formik.values.donationFrequency === "unselected"
                ? styleSelect
                : styleSelectWithValue
            }
            components={{ Option: CheckboxFrequencyOption }}
            className={style.mi_select_style_class}
            placeholder="Elegir periodicidad*"
            classNamePrefix="select"
            onChange={(option) =>
              formik.setFieldValue(
                "donationFrequency",
                option ? option.value : null
              )
            }
            value={
              frequencyOptions.find(
                (option) => option.value === formik.values.donationFrequency
              ) || "unselected"
            }
          />
          {formik.touched.donationFrequency &&
          formik.errors.donationFrequency ? (
            <div className={style.error_style_form}>
              {formik.errors.donationFrequency}
            </div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <input
            id="iban"
            name="iban"
            type="text"
            className={`${
              formik.values.iban
                ? style.input_custom_type_with_value
                : style.input_custom_type
            }`}
            onChange={formik.handleChange}
            onBlur={handleBlur}
            value={formik.values.iban}
            placeholder="IBAN: DE89300400000530013000"
          />
          {formik.touched.iban && formik.errors.iban ? (
            <div className={style.error_style_form}>{formik.errors.iban}</div>
          ) : null}
        </div>
        <div className={style.div_container_element_style}>
          <label className={style.policy_acept_container}>
            <input
              className={style.input_custom}
              type="checkbox"
              checked={policePrivacity}
              onChange={() => setPolicePrivacity(!policePrivacity)}
            />
            <span className={style.checkbox_container}></span>
            <p style={{ marginLeft: "10px" }}>
              He leído y acepto la{" "}
              <span>
                <a
                  target="_blank"
                  href="https://www.fundacionbavieraresponsable.org/politica-privacidad/"
                  style={{ textDecoration: "none" }}
                >
                  Política de Privacidad
                </a>
              </span>
            </p>
          </label>
          {policePrivacity === false && showPolicePrivacityError === true ? (
            <div className={style.error_style_form}>
              Debes aceptar los términos y condiciones
            </div>
          ) : null}
        </div>
      </div>
      <div className={style.send_btn_style}>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <button
          disabled={loading}
          className={style.button_send}
          type="submit"
          onClick={clickOnSendForm}
        >
          {!loading ? "Enviar" : "Enviando formulario..."}
        </button>
      </div>
    </form>
  );
}
